import {
    type FC
} from "react";
import type IDropdownMenuContentProps from "./type";
import {
    useDropdownMenuContext
} from "../../context";
import DropdownMenuSurface from "../surface";
import DropdownMenuSheet from "../sheet";

const DropdownMenuContent: FC<IDropdownMenuContentProps> = ({
    customTheme: customThemeProp,
    widthBehaviour = "content",
    children,
    style
}) => {
    const context = useDropdownMenuContext({
        part: "Content"
    });

    if(!context) {
        return null;
    }

    const customTheme = customThemeProp ?? context.customTheme;

    if(context.isSheet) {
        return <DropdownMenuSheet
            customTheme={customTheme}
        >
            {children}
        </DropdownMenuSheet>;
    }

    const isContextMenu = context.kind === "context";

    return <DropdownMenuSurface
        aria-labelledby={context.title || isContextMenu ? undefined : context.triggerId}
        anchorRef={isContextMenu ? context.pointerAnchorRef : context.anchorRef}
        isOpen={context.isOpen && (!isContextMenu || !!context.pointer)}
        triggerWidth={isContextMenu ? 0 : context.triggerWidth}
        offset={isContextMenu ? 0 : undefined}
        widthBehaviour={widthBehaviour}
        onDismiss={context.handleClose}
        openMode={context.openMode}
        aria-label={context.title}
        customTheme={customTheme}
        id={context.contentId}
        align={context.align}
        side={context.side}
        style={style}
        level={0}
    >
        {children}
    </DropdownMenuSurface>;
};
export default DropdownMenuContent;
